var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4699",
    "data-name": "Group 4699",
    transform: "translate(-1556 -806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-mobile-1086535",
    transform: "translate(1540.771 803.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4698",
    "data-name": "Group 4698",
    transform: "translate(23 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13083",
    "data-name": "Path 13083",
    d: "M36.716,5H25.743A2.743,2.743,0,0,0,23,7.743V29.688a2.743,2.743,0,0,0,2.743,2.743H36.716a2.743,2.743,0,0,0,2.743-2.743V7.743A2.743,2.743,0,0,0,36.716,5ZM38.91,29.688a2.2,2.2,0,0,1-2.195,2.195H25.743a2.2,2.2,0,0,1-2.195-2.195V7.743a2.2,2.2,0,0,1,2.195-2.195H36.716A2.2,2.2,0,0,1,38.91,7.743Z",
    transform: "translate(-23 -5)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13084",
    "data-name": "Path 13084",
    d: "M27.5,34.574H41.216V14H27.5Zm.549-20.025H40.667V34.025H28.049Z",
    transform: "translate(-26.128 -11.257)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1317",
    "data-name": "Rectangle 1317",
    width: 2.743,
    height: 0.549,
    transform: "translate(6.858 1.372)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13085",
    "data-name": "Path 13085",
    d: "M46.872,82.85a1.372,1.372,0,1,0,1.372,1.372A1.372,1.372,0,0,0,46.872,82.85Zm0,2.195a.823.823,0,1,1,.823-.823A.824.824,0,0,1,46.872,85.045Z",
    transform: "translate(-38.642 -59.122)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1318",
    "data-name": "Rectangle 1318",
    width: 32,
    height: 32,
    transform: "translate(1556 806)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconActive);
export default __webpack_public_path__ + "static/media/phone-icon-active.03c8f9efe109b1bcd7587cf418273323.svg";
export { ForwardRef as ReactComponent };